import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export function useSearchParams() {
  const { push } = useHistory()
  const { pathname, search } = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  const updateSearchParam = useCallback(
    (paramName: string, value: string) => {
      searchParams.set(paramName, value)
      push(`${pathname}?${searchParams.toString()}`)
    },
    [pathname, push, searchParams],
  )

  return useMemo(
    () => ({
      searchParams,
      updateSearchParam,
    }),
    [searchParams, updateSearchParam],
  )
}
